import { Box, Paper, styled, TextField } from '@mui/material';

/**
 * Runs the full height of the screen, alongside the toolbar rather than under it, so the
 * conversation has the same room as the roster it is about.
 */
export const StyledPanel = styled(Paper)(({ theme }) => ({
  width: theme.spacing(100),
  flexShrink: 0,
  height: 'calc(100vh - 140px)', // Note: matches the page padding, not the toolbar
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  overflow: 'hidden',
  border: `1px solid ${theme.palette.divider}`
}));

export const StyledHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  padding: theme.spacing(3, 3, 3, 4),
  borderBottom: `1px solid ${theme.palette.divider}`
}));

export const StyledHeaderTitleBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  minWidth: 0
}));

export const StyledMessageList = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(4)
}));

export const StyledComposer = styled('form')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  gap: theme.spacing(2),
  padding: theme.spacing(3, 4),
  borderTop: `1px solid ${theme.palette.divider}`
}));

export const StyledQuestionField = styled(TextField)(() => ({
  flex: 1
}));

export const StyledSuggestionsBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1.5)
}));
